import { RSAA } from 'redux-api-middleware'
import { ACCEPT_JSON_HEADERS } from '../config/api'
import {
  submittableAblePortalApiRequest,
  submittableAccountSystemApiRequest,
  submittableAuthorizationManagementApiRequest,
  submittableCSRApiRequest,
  submittableFundsDistritubtionApiRequest,
  submittableInternalAdminApiRequest,
  submittableOrganizationsApiRequest,
} from '../config/authentication'
import { setApplicationRoles } from '../reducers/application/roles'
import { getMsalPca } from '../services/authentication'
import { errorNotification } from '../reducers/application/notifications'

export const CALL_INTERNAL_API = '@@call-api-with-internal-api-jwt/RSAA'
export const CALL_FUNDS_DISTRIBUTION_API = '@@funds-distribtuion-api-jwt/RSAA'
export const CALL_CSR_API = '@@csr-api-jwt/RSAA'
export const CALL_ABLE_PORTAL_API = '@@able-portal-api-jwt/RSAA'
export const CALL_ACCOUNT_SYSTEM_API = '@@account-system-api-jwt/RSAA'
export const CALL_ORGANIZATIONS_API = '@@organizations-api-jwt/RSAA'
export const CALL_AUTHORIZATION_MANAGEMENT_API = '@@authorization-management-api-jwt/RSAA'

const getRequest = (pca, rsaa) => {
  const accounts = pca.getAllAccounts()
  if (rsaa === CALL_INTERNAL_API) {
    return {
      ...submittableInternalAdminApiRequest,
      account: accounts[0],
    }
  }
  if (rsaa === CALL_FUNDS_DISTRIBUTION_API) {
    return {
      ...submittableFundsDistritubtionApiRequest,
      account: accounts[0],
    }
  }
  if (rsaa === CALL_CSR_API) {
    return {
      ...submittableCSRApiRequest,
      account: accounts[0],
    }
  }
  if (rsaa === CALL_ABLE_PORTAL_API) {
    return {
      ...submittableAblePortalApiRequest,
      account: accounts[0],
    }
  }
  if (rsaa === CALL_ACCOUNT_SYSTEM_API) {
    return {
      ...submittableAccountSystemApiRequest,
      account: accounts[0],
    }
  }
  if (rsaa === CALL_ORGANIZATIONS_API) {
    return {
      ...submittableOrganizationsApiRequest,
      account: accounts[0],
    }
  }
  if (rsaa === CALL_AUTHORIZATION_MANAGEMENT_API) {
    return {
      ...submittableAuthorizationManagementApiRequest,
      account: accounts[0],
    }
  }

  return { account: accounts[0] }
}

export const getAuthToken = async (store, pca, rsaa) => {
  const request = getRequest(pca, rsaa)
  let result

  try {
    result = await pca.acquireTokenSilent(request)
  } catch (error) {
    console.log('Silent token acquisition failed', error)
    if (request.account) {
      await pca.logoutRedirect({
        postLogoutRedirectUri: window.AZURE_AD_REDIRECT_URI,
      })
    }
  }

  store.dispatch(setApplicationRoles(result?.idTokenClaims?.roles ?? []))
  const authenticatedUserId = result?.idTokenClaims?.oid ?? 'submittable-admin'
  const token = [result?.accessToken, authenticatedUserId]
  localStorage.setItem('username', result?.idTokenClaims?.name)
  return token
}

const pca = getMsalPca()
const buffer = new Map()

const authHeaders = rsaa => store => next => async action => {
  if (action?.[rsaa]) {
    let promise
    if (buffer.has(rsaa)) {
      promise = buffer.get(rsaa)
    } else {
      promise = getAuthToken(store, pca, rsaa)
      buffer.set(rsaa, promise)
    }

    const [token, userId] = await promise
    buffer.delete(rsaa)

    const { headers = {}, ...rest } = action[rsaa]

    return next({
      [RSAA]: {
        ...rest,
        credentials: 'omit',
        headers: {
          ...ACCEPT_JSON_HEADERS,
          ...headers,
          Authorization: `Bearer ${token}`,
          'authenticated-user-id': `submittable-admin-${userId}`,
        },
      },
    }).then(response => {
      // globally handle errors for CSR api requests
      if (rsaa === CALL_CSR_API || rsaa === CALL_ACCOUNT_SYSTEM_API) {
        let errorMessage = 'Something went wrong'
        let hasError = false
        if (response?.error) {
          hasError = true
          errorMessage =
            (rsaa === CALL_ACCOUNT_SYSTEM_API
              ? response?.payload?.response?.message
              : response?.payload?.message) ?? errorMessage
        } else if (response?.payload?.hasError) {
          hasError = true
          errorMessage = response?.payload.errors?.join(', ') ?? errorMessage
        }
        if (hasError) {
          store.dispatch(
            errorNotification({
              body: errorMessage,
              dismissInSeconds: 5,
            })
          )
        }
      }
      return response
    })
  }
  return next(action)
}

export const getInitialAuthorization = store => {
  return getAuthToken(store, pca, CALL_INTERNAL_API)
}

export default authHeaders
